import {
  GET_PROCESS_STATE,
  GET_SELECTED_FILE,
  GET_UPLOAD_PROGRESS,
  GET_VALIDATION_RESULT,
  GET_PROCESS_RESULT,
  GET_UPLOAD_DRAWER_OPEN,
  GET_DELETE_DRAWER_OPEN,
  GET_CURRENT_STEP,
  GET_ERRORS
} from "../getters.js";

export default {
  [GET_PROCESS_STATE]: (state) => state.processState,
  [GET_SELECTED_FILE]: (state) => state.selectedFile,
  [GET_UPLOAD_PROGRESS]: (state) => state.uploadProgress,
  [GET_VALIDATION_RESULT]: (state) => state.validationResult,
  [GET_PROCESS_RESULT]: (state) => state.processResult,
  [GET_UPLOAD_DRAWER_OPEN]: (state) => state.uploadDrawerOpen,
  [GET_DELETE_DRAWER_OPEN]: (state) => state.deleteDrawerOpen,
  [GET_CURRENT_STEP]: (state) => state.currentStep,
  [GET_ERRORS]: (state) => state.errors
};
